import axios from 'axios';
import * as myFlow from '@flow/store/myflow/actions';
import { GetListWithId, SetUserTimetableFromListId, UpdateArtist } from 'types/MyFlow';
import {
  ARTIST_UPDATED,
  LOADING_USER_LIST_TIMETABLE,
  SET_USER_LIST_TIMETABLE,
  USER_TIMETABLE_SAVED
} from '@flow/store/myflow/constants';

const API_BASE = process.env.REACT_STATIC_ENV === 'development' ? '//localhost:8080' : '//cms.flowfestival.com';
const API_PATH = `${API_BASE}/custom/save_user_timetable.php`;

const createFormData = (data: any) => {
  const formData: FormData = new FormData();

  if (!data) {
    return formData;
  }

  Object.keys(data).map(key => {
    formData.append(key, data[key]);
  });

  return formData;
};

const timetableAPIPostCall = (action: string, data: any) => {
  const payload = createFormData(data);

  return axios({
    method: 'POST',
    url: `${API_PATH}?action=${action}`,
    data: payload,
  });
};

export const fetchUserList = () => {
  return (dispatch: any, getSate: any) => {
    const {
      myFlowReducer: {
        facebook,
      }
    } = getSate();

    timetableAPIPostCall('get', { fb_id: facebook.userId })
      .then(response => {
        if (response.data !== 'error') {
          const splittedData = response.data.split('__ID__');

          if (splittedData[1]) {
            const timetable = splittedData[1].split(',');

            dispatch(myFlow.setUserTimetable({ timetable }));
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
  };
};

export const saveUserList = () => {
  return (dispatch: any, getSate: any) => {
    const {
      myFlowReducer: {
        facebook,
        scheduleIdList,
      },
      navigationReducer: {
        appLanguage: {
          code,
        }
      }
    } = getSate();

    timetableAPIPostCall('save', {
      fb_id: facebook.userId,
      artist_ids: scheduleIdList.join(','),
      lang: code,
    })
      .then(response => {
        console.info(response.data);
        dispatch(userListSaved());
      })
      .catch(error => {
        console.log(error);
      });
  };
};

export const updateArtist = ({
  action,
  id
}: UpdateArtist) => {
  return (dispatch: any, getSate: any) => {
    const {
      navigationReducer: {
        appLanguage: {
          code,
        }
      }
    } = getSate();

    try {
      timetableAPIPostCall(action, {
        id,
        lang: code,
      }).then(() => {
        dispatch(artistUpdated());
      });
    } catch (e) {
      console.log(e);
    }
  }
};

export const artistUpdated = () => {
  return {
    type: ARTIST_UPDATED,
  };
};

export const userListSaved = () => {
  return {
    type: USER_TIMETABLE_SAVED,
  };
};

export const loadingUserList = () => {
  return {
    type: LOADING_USER_LIST_TIMETABLE
  };
};

export const setMyFlowTimetableFromListId = ({
  timetable,
  success,
  error,
}: SetUserTimetableFromListId) => {
  return {
    type: SET_USER_LIST_TIMETABLE,
    timetable,
    success,
    error,
  };
};

export const getListWithId = ({
  listId,
}: GetListWithId) => {
  return (dispatch: any) => {
    timetableAPIPostCall('get', { fb_id: listId })
      .then(response => {
        if (response.data !== 'error') {
          const splitData = response.data.split('__ID__');

          if (splitData[1]) {
            const timetable = splitData[1].split(',');

            dispatch(setMyFlowTimetableFromListId({
              timetable,
              success: true,
              error: false,
            }));
          }
        } else {
          // No list found
          dispatch(setMyFlowTimetableFromListId({
            timetable: [],
            success: false,
            error: true,
          }));
        }
      })
      .catch(error => {
        console.log(error);
        dispatch(setMyFlowTimetableFromListId({
          timetable: [],
          success: false,
          error: true,
        }));
      });
  };
};


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/myflow/API.ts